// extracted by mini-css-extract-plugin
export default {"wrapper":"ToastLinkCopied_wrapper__RhY9N","disabled":"ToastLinkCopied_disabled__47rCR","content":"ToastLinkCopied_content__ipuH8"};